/* __next_internal_client_entry_do_not_use__ UnobservedIntlProvider auto */ import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx } from "react/jsx-runtime";
import { LocalizationProvider } from "@faire/web--source/common/localization/useLocalization";
import { buildLocale } from "@faire/web--source/common/localization/utils";
import React, { useMemo } from "react";
import { IntlProvider as ReactIntlProvider } from "react-intl";
import { DEFAULT_LOCALE, DEFAULT_LOCALE_KEY } from "../consts/DEFAULT_LOCALE";
import { LocalizationStore } from "./LocalizationStore";
export var UnobservedIntlProvider = function(_param) {
    var children = _param.children, args = _object_without_properties(_param, [
        "children"
    ]);
    var _args_localeKey, _ref;
    var localeKey = (_ref = (_args_localeKey = args.localeKey) !== null && _args_localeKey !== void 0 ? _args_localeKey : LocalizationStore.get().localeKey) !== null && _ref !== void 0 ? _ref : DEFAULT_LOCALE_KEY;
    var locale = useMemo(function() {
        return buildLocale(localeKey);
    }, [
        localeKey
    ]);
    var _args_defaultLocale, _args_messages;
    return /*#__PURE__*/ _jsx(ReactIntlProvider, _object_spread_props(_object_spread({}, args), {
        defaultLocale: (_args_defaultLocale = args.defaultLocale) !== null && _args_defaultLocale !== void 0 ? _args_defaultLocale : DEFAULT_LOCALE,
        locale: locale,
        messages: (_args_messages = args.messages) !== null && _args_messages !== void 0 ? _args_messages : LocalizationStore.get().messages,
        children: /*#__PURE__*/ _jsx(LocalizationProvider, _object_spread_props(_object_spread({}, args), {
            children: children
        }))
    }));
};
